module.exports = __webpack_public_path__ + "media/assets/faria_products/OSC-9ae5a1549d2c068fc735c15cd2370ef473bcbdd4e970fe62d67c20269730df60.png";